const foreign_worker_uischema = {
  view: "main",
  title: "Foreign Worker Profiles",
  entity: "Firms",
  linkBack: {
    name: "Back to Profiles",
    link: "/dashboard/profiles/",
  },
  button: {
    name: "New Foreign Worker Profile",
    style: "default",
  },
  navigateButton: {
    name: "Foreign Worker Profile Groups",
    style: "outline",
    nav: "/dashboard/profiles/foreign-worker-group/",
  },
};

export default foreign_worker_uischema;
